import { Grid, makeStyles, Typography, Checkbox as MuiCheckbox } from "@material-ui/core";

const useStyles = makeStyles(() => ({
  root: {
    width: "fit-content",
  },
}));

export const Checkbox = ({ checked, defaultChecked, text, onChange, style }) => {
  const classes = useStyles();

  return (
    <Grid className={classes.root} container alignItems="center" style={style}>
      <MuiCheckbox
        checked={checked}
        color="primary"
        defaultChecked={defaultChecked}
        onChange={onChange}
      />
      {text && <Typography style={{ fontWeight: 600 }}>{text}</Typography>}
    </Grid>
  );
};
